// extracted by mini-css-extract-plugin
module.exports = {"logo":"style__logo__scpJ6","wrapper":"style__wrapper__eBbUz"};